export const DANCE_FILTER_CATEGORIES = [
    'name',
    'style',
    'creators',
    'performer',
    'composer',
    'lyricist',
    'creationDate',
    'danceMediasIcons',
]
export const RESULTS_PER_SEARCH_PAGE = 10

export const SEARCH_INPUTS_LIST = ['name', 'creators', 'artist']

export const ADVANCED_SEARCH_FIELDS = ['name', 'creators', 'artist']

export const getSearchValueFromAutocompleteOption = (option, searchField) => {
    if (searchField === ADVANCED_SEARCH_FIELDS[0]) {
        return option?.[searchField]
    }
    return option?._id
}

export const AUTOCOMPLETE_OPTION_LIMIT = 10

export const PAGE_SIZE = [10, 20, 50, 100]
export const DANCE_STYLES = [
    'lines',
    'threeWay',
    'couples',
    'circle',
    'couplesSwap',
    'kids',
    'kidsCouples',
    'kidsCircle',
    'kidsLines',
]

export const DANCE_STYLE_LABELS = {
    [DANCE_STYLES[0]]: 'שורות',
    [DANCE_STYLES[1]]: 'שלשות',
    [DANCE_STYLES[2]]: 'זוגות',
    [DANCE_STYLES[3]]: 'מעגל',
    [DANCE_STYLES[4]]: 'זוגות מתחלפים',
    [DANCE_STYLES[5]]: 'ילדים',
    [DANCE_STYLES[6]]: 'ילדים-זוגות',
    [DANCE_STYLES[7]]: 'ילדים-מעגל',
    [DANCE_STYLES[8]]: 'ילדים-שורות',
}

export const DANCE_OPTIONS = [
    {title: 'שורות', value: 'שורות'},
    {title: 'שלשות', value: 'שלשות'},
    {title: 'זוגות', value: 'זוגות'},
    {title: 'מעגל', value: 'מעגל'},
    {title: 'זוגות מתחלפים', value: 'זוגות מתחלפים'},
    {title: 'ילדים', value: 'ילדים'},
    {title: 'ילדים-זוגות', value: 'ילדים-זוגות'},
    {title: 'ילדים-מעגל', value: 'ילדים-מעגל'},
    {title: 'ילדים-שורות', value: 'ילדים-שורות'},
]

export const PAGE_ACTION = {
    prev: 'previous',
    next: 'next',
}
